import React from 'react';
import { FormLabel, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import ListItem from './ListItem';

function PreviewImages({
  files,
  name,
  setDisabledForm,
  required = false,
  onUpload,
  handleDelete,
}: any) {
  if (!files.length) {
    return null;
  }

  return (
    <>
      <FormLabel component="legend" required={required} sx={{ py: 2 }}>
        <FormattedMessage id="POST_FORM.ATTACHMENTS_IMAGES" /> (jpg, png, gif,…)
      </FormLabel>

      <Stack
        direction="row"
        useFlexGap
        sx={{
          gap: 2,
          flexWrap: 'wrap',
        }}
      >
        {files.map((file: any) => (
          <ListItem
            name={name}
            layout="image"
            key={`${name}-${file.name || file.title}`}
            file={file}
            setDisabledForm={setDisabledForm}
            onCancel={(fileOrBlobId: any) => handleDelete(fileOrBlobId, file)}
            onUpload={onUpload}
          />
        ))}
      </Stack>
    </>
  );
}

export default PreviewImages;
